const BIG_COMPANY_SIZE = 100;

export const isBigCompany = (companyData) => {
  return companyData?.success && companyData?.data?.company?.metrics?.employees >= BIG_COMPANY_SIZE;
};
